import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

/**
 * Pagination Component
 * Renders the pagination controls.
 */
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalUsers,
  limit,
}) => {
  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * limit + 1;
  const endItem = Math.min(currentPage * limit, totalUsers);

  return (
    <div className="text-s-text mt-6 flex flex-col items-center justify-between sm:flex-row">
      <p className="mb-4 text-sm sm:mb-0">
        Showing <span className="text-p-text font-semibold">{startItem}</span>{' '}
        to <span className="text-p-text font-semibold">{endItem}</span> of{' '}
        <span className="text-p-text font-semibold">{totalUsers}</span> results
      </p>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="hover:bg-2 rounded-lg p-2 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        >
          <IoChevronBack className="h-5 w-5" />
        </button>
        <span className="text-p-text text-sm font-medium">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="hover:bg-2 rounded-lg p-2 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        >
          <IoChevronForward className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
